<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-numeric-edit-control formControlName="recipeQuantity"
                                              [(ngModel)]="model.data.recipeQuantity"></wbo-numeric-edit-control>
                    <ng-container formGroupName="recipeStockSize">
                        <ng-container formGroupName="measure">
                            <wbo-inventory-recipe-size-single-select-edit-control formControlName="measureId"
                                                                                  [(ngModel)]="model.data.recipeStockSize.measure.measureId"
                                                                                  [inventoryId]="model.data.inventoryId"
                                                                                  [measureId]="model.data.standardStockSize.measure.measureId"
                                                                                  (onSelect)="populateRecipe($event)"
                            ></wbo-inventory-recipe-size-single-select-edit-control>
                        </ng-container>
                    </ng-container>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <wbo-text-edit-control formControlName="name" [readonly]="true"></wbo-text-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-column>
            <wbo-edit-grid [data]="model.data.recipeItems" [entityPath]="'recipeItems'"
                           [editable]="true" [removable]="true">
                <wbo-edit-link-column field="inventory.name" componentPath="inventory"
                                      [editComponent]="InventoryEditPageComponent"
                                      [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                <wbo-numeric-column field="amount" [editable]="true"></wbo-numeric-column>
                <wbo-inventory-stock-size-single-select-column field="stockSize" [editable]="true"
                                                               [inventoryIdField]="'inventory.inventoryId'"></wbo-inventory-stock-size-single-select-column>
                <wbo-edit-grid-add-row [identifierField]="'inventoryId'" componentPath="inventory" #addRow
                                       [customAddQuickSelect]="true">
                    <wbo-edit-grid-add-row-quick-add (onSelect)="addRow.addRow($event, true)">
                        <wbo-inventory-single-select-edit-control></wbo-inventory-single-select-edit-control>
                    </wbo-edit-grid-add-row-quick-add>
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-search
                            [searchComponent]="InventorySearchPageComponent"
                            [searchParams]="{filterNonStockable : true}"></wbo-edit-grid-add-row-search>
                        <wbo-edit-grid-add-row-new-entity
                            [editComponent]="InventoryEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-column>
    </fui-row>
</fui-rows>
